import { Helmet } from "react-helmet-async";
import { Box, Breadcrumbs, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { getDocumentTitle } from "@/utils";
import { DashboardCanvas } from "../../components/DashboardCanvas";

export function SalesSummaryPage() {
  return (
    <Box>
      <Helmet>
        <title>{getDocumentTitle("วิเคราะห์การขาย")}</title>
      </Helmet>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{ mb: 5 }}
      >
        <Typography color="text.primary">วิเคราะห์การขาย</Typography>
      </Breadcrumbs>
      <DashboardCanvas title="วิเคราะห์การขาย" type="sales" />
    </Box>
  );
}
